<!--
   Created by qing on 2020/3/11 7:38 下午
   Des:
-->
<template>
  <div class="select-container">
    <div class="select-content" @click="onClickSelect">
      {{showLabel}}
    </div>
    <van-dialog
      class="ry-select-dialog"
      v-model="visible"
      :title="title"
      get-container="body"
      show-cancel-button
      @confirm="confirmSelect">
      <van-radio-group v-model="select">
        <van-radio
          v-for="item in dataSource"
          :key="isObject ? item[idKey] : item"
          :name="isObject ? item[idKey] : item"
          checked-color="#07c160">
          {{isObject ?item[label] : item}}
        </van-radio>
      </van-radio-group>
    </van-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      value: String | Object,
      title: {
        type: String,
        default: ''
      },
      dataSource: {
        type: Array,
        default: () => []
      },
      // 数据源数组中是否是对象
      isObject: {
        type: Boolean,
        default: true
      },
      // 如果是对象，获取显示的名称的key
      label: {
        type: String,
        default: ''
      },
      // 如果是对象，获取唯一标识的key
      idKey: {
        type: String,
        default: ''
      },
      // 返回值的key,如果没传，返回选择的对象
      valueKey: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        visible: false,
        select: this.value
      };
    },
    computed: {
      showLabel() {
        const item = this.dataSource.filter(item => item[this.idKey] === this.select)[0] || ''
        return this.isObject ? item[this.label] : this.select
      }
    },
    methods: {
      onClickSelect() {
        this.visible = true
      },
      confirmSelect() {
        let value = null
        if (this.isObject) {
          if (this.valueKey.length) {
            // 返回对象中的某个属性
            let item = this.dataSource.filter(item => item[this.idKey] === this.select)[0] || {}
            value = item[this.valueKey]
          } else {
            // 返回整个对象
            value = this.dataSource.filter(item => item[this.idKey] === this.select)[0]
          }
        } else {
          value = this.select
        }
        this.$emit("update:value", value)
        this.$emit("change", value)
      }
    }
  };
</script>

<style lang="less">

  .select-container {

    .select-content {
      width: 50px;
      height: 100%;
      padding: 0 10px;
      border-bottom: 1px solid #19be6b;
    }

  }

  .ry-select-dialog {

    .van-dialog__content {
      margin: 10px;
    }

    .van-radio-group {
      max-height: 400px;
      overflow: auto;
    }

    .van-radio {
      margin-bottom: 10px;
    }
  }
</style>